import React from "react";
import "../../../../style/buttons.scss";

interface IProps {
  title: string | React.ReactNode;
  variant?: "filled" | "outlined" | "text" | "caption";
  color?: "primary" | "secondary" | "error" | "dark";
  onClick?: () => void;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  fullWidth?: boolean;
  disabled?: boolean;
  inputType?: "button" | "submit" | "reset" | undefined;
  loading?: boolean;
  loadingText?: string;
  noMargins?: boolean;
  compact?: boolean;
  /** Gdy podane (i przycisk nie jest disabled/loading), renderuje się jako <a href>
   * zamiast <button> — prawdziwa nawigacja przeglądarki, niezależna od window.open/JS,
   * której popup-blockery nie blokują. onClick nadal się wykonuje (np. dodatkowy window.open). */
  href?: string;
  target?: string;
  rel?: string;
}

const EAButton: React.FC<IProps> = ({
  title,
  variant = "filled",
  color = "primary",
  onClick = () => {},
  startIcon,
  endIcon,
  fullWidth = false,
  disabled = false,
  inputType = "button",
  loading = false,
  loadingText = "Ładowanie...",
  noMargins = false,
  compact = false,
  href,
  target,
  rel,
}) => {
  const className = `button button--${variant} button--${color} ${fullWidth ? "button--fullWidth" : ""} ${
    noMargins ? "button--no-margins" : ""
  } ${compact ? "button--compact" : ""}`;

  const content = loading ? (
    <span className="button__text button-text">{loadingText}</span>
  ) : (
    <>
      {" "}
      {startIcon && <span className="button__icon button__icon--start">{startIcon}</span>}
      <span className="button__text button-text">{title}</span>
      {endIcon && <span className="button__icon button__icon--end">{endIcon}</span>}
    </>
  );

  if (href && !disabled && !loading) {
    return (
      <a className={className} href={href} target={target} rel={rel} onClick={onClick}>
        {content}
      </a>
    );
  }

  return (
    <button className={className} onClick={onClick} disabled={disabled || loading} type={inputType}>
      {content}
    </button>
  );
};

export default EAButton;
